import React from 'react';
import './dual-toggle-switch.scss';

interface DualToggleSwitchProps {
    checked: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    leftLabel: string;
    rightLabel: string;
    disabled?: boolean;
}

const DualToggleSwitch: React.FC<DualToggleSwitchProps> = ({ checked, onChange, leftLabel, rightLabel, disabled }) => {
    return (
        <label className="dual-toggle-switch">
            <span className={`toggle-label left ${!checked ? 'active' : ''}`}>{leftLabel}</span>
            <div className="toggle-wrapper">
                <input type="checkbox" checked={checked} onChange={onChange} disabled={disabled} />
                <span className="toggle-slider" />
            </div>
            <span className={`toggle-label right ${checked ? 'active' : ''}`}>{rightLabel}</span>
        </label>
    );
};

export default DualToggleSwitch;
